export const messageContent = {
  hasSpecialCharacter: `「&<>"'」を入力しないでください。`,
  hasSpecialCharacterForLog: `「&<>」を入力しないでください。`,
  infoModalTitle: `Info`,
  errorModalTitle: `エラー`,
  confirmModalTitle: `Confirm`,
  fullnameNotIncludeUndebar: `「_」（アンダーバー）文字を入力しないでください。`,
  allFieldIsRequired: `すべての項目に値を入力してください。`,
  passwordNotSame: `パスワードと新しいパスワードの確認が一致していません。`,
  onlySpaceError: 'スペースだけで入力しないでください。',
  incomingGroupSaved: '着信グループを保存しました。',
  guidanceRequired: 'ガイダンス内容を入力してください。',
  exceedTransferCountLimit: '転送回数の上限を超えました。転送できません。',
  exceedHoldCountLimit: '保留回数の上限を超えました。保留できません。',
  callIsHolding: '通話相手が保留中です。保留できません。',
  parkHoldIsUsing: 'このパークが使用中です。保留できません。',
  mailAuthInChangePassword:
    'パスワードを変更し、ご登録のメールアドレスに、メールリンク認証用のURLを送付いたしましたのでご確認ください。',
  passwordCondition:
    '※ パスワードは12文字〜40文字で、大文字アルファベット、小文字アルファベット、数字をすべて１つ以上含ませてください。',
  confirmDelteText: '音声テキスト化結果を削除しますか？',
  confirmDeleteRecording:
    '通話録音ファイルを削除すると、テキストも一緒に<br>削除されます。<br>元に戻すことはできません。<br>本当に削除してよろしいですか？',
  confirmDeleteRecordingOther:
    '通話録音ファイルを削除します。<br>元に戻すことはできません。<br>本当に削除してよろしいですか？',
  notExistText:
    '音声テキスト化結果が存在しません。<br>テキスト化中の場合、テキスト化には<br>通話時間1分あたり約30秒の時間がかかります。<br>しばらくお待ちください。',
  emptyVoice: 'テキスト化される音声はありませんでした。',
  failDownloadText: '音声テキスト化結果情報の取得中にエラーが発生しました。時間を空けて再度実行してください。',
  //POCのため、料金の文言は消す。#3650
  // confirmDoVoiceToText: '音声テキスト化を実行しますか？<br>テキスト化1回あたり ***円（税込）の料金が今月分より加算されます。<br>通話時間1分あたり約30秒の時間がかかります。',
  confirmDoVoiceToText: '通話録音テキスト化を実行しますか？<br>通話時間1分あたり約30秒の時間がかかります。',
  requestDoVoiceToTextSetting:
    '通話録音テキスト化機能がOFFです。<br>通話録音テキスト化を利用する場合は <a href="/voicetotext">こちらのページ</a> にて設定をしてください。',
  confirmVoiceToTextSettingChange:
    '上記の通りに設定を変更します。よろしければOKボタンを押してください。<br>※テキスト化した通話毎に料金が発生しますのでご注意ください。',
  confirmVoiceToTextSettingChangeTitle: '通話録音テキスト化機能　ご利用確認',
  callLogDownloadError: '発着信履歴ダウンロード中にエラーが発生しました。時間を空けて再度実行してください。',
  notSetTransferNumber: 'お客様が利用されている番号を転送先に設定することはできません。',
  trialCompanyIsContracted: 'このトライアル契約IDは既に本申し込み済みのため、申し込みできません。',
  trialCompanyHideFrequency: 'トライアル契約IDでは、カウントされた度数は表示されません。',
  cannotCallDuringCall: '通話中のユーザーは発信できません。',
  cancelOutboundCallError:
    '発信処理がタイムアウトしました。メモの保存はできません。この番号への発信が必要な場合はもう一度発信ボタンをクリックしてください。',
  methods: {
    notSetItem: function (item) {
      return item + 'が設定されていません。';
    },
    storeItem: function (item) {
      return item + 'を保存しました。';
    },
    existItem: function (item) {
      return item + 'は既に存在しています。';
    },
  },

  // #2874
  requireTry: item => {
    return item + '中にエラーが発生しました。時間を空けて再度実行してください。';
  },
  requireNotSpecialCharacter: item => {
    return item + 'に「&<>"\'」を入力しないでください。';
  },
  requireItemNotInput: () => {
    return '必須入力項目に値が入っていませんでした。入力をしなおしてください。';
  },
  requireUploadFile: item => {
    return item + 'のアップロードファイルを指定してください。';
  },
  requireInput: item => {
    return item + 'を入力してください。';
  },
  requireInputFormat: item => {
    return item + 'で入力してください。';
  },
  requireAdd: item => {
    return item + 'を追加してください。';
  },
  requireNotSymbolCharacters: item => {
    return item + 'に記号文字を入力しないでください。';
  },
  requireUnderMaximumNumberOfCharacters: (item, num) => {
    return item + 'の最大文字数は' + num + '文字です。';
  },
  alertDriverLicense: item => {
    return item + 'は表と裏を指定してください。';
  },
  alertIdentification: item => {
    return item + 'は1枚のみ指定してください。';
  },
  requireChoice: item => {
    return item + 'を選択してください。';
  },
  alertUploadfileSizeExceeded: maxSize => {
    return 'アップロードするファイルは' + maxSize + 'MBまでとなっております。';
  },
  alertUploadfileNameSizeExceeded: maxSize => {
    return 'アップロードするファイル名は' + maxSize + '文字までとなっております。';
  },
  notReleaseVDXAndCCCUnlessDeleteNumber: () => {
    return 'COTOHA Voice DX Basicで利用している番号をすべて削除しないと解約できません。';
  },
  alertMultiple050NumbersUsing: () => {
    return '050番号が複数存在しています。電話番号管理画面から050番号の廃止申込が必要です。';
  },
  titleCancelContract: () => {
    return '解約の確認';
  },
  alertCancelContract: () => {
    return '本当に解約してよろしいですか？';
  },
  alertCancelReason: () => {
    return '解約理由を選択してください。';
  },
  alertNotCorrectFormat: item => {
    return item + 'の形式が正しくありません。';
  },
  notifyCancelContractAccepted: () => {
    return '解約の申請を受け付けました。';
  },
  notifyChangeContractAccepted: () => {
    return '契約変更の申請を受け付けました。';
  },
  notifyPhoneBookAdd: () => {
    return '連絡先を登録しました。';
  },
  notifyPhoneBookSaved: () => {
    return '連絡先を保存しました。';
  },
  notifyPhoneBookDeleted: () => {
    return '連絡先を削除しました。';
  },
  confirmPhoneBookEntryDelete: () => {
    return 'この連絡先を削除しますか？';
  },
  notifyApplyInfoChanged: () => {
    return '申し込み情報を変更しました。';
  },
  notifySearching: () => {
    return '検索中です';
  },
  notifyCompanyInfoAdd: () => {
    return '企業情報を登録しました。';
  },
  notifyTmpCompanyInfoAdd: () => {
    return '企業情報を申し込みとして登録しました。';
  },
  notifyChangeApplyAccepted: () => {
    return '変更申請を承認しました。';
  },
  notifyStatusChangeToRejected: () => {
    return 'ステータスを「否認」に変更しました。';
  },
  alertNowCanceling: () => {
    return '現在解約中のため申請できません。';
  },
  alertNowApplying: () => {
    return '現在申請中のため変更できません。';
  },
  alertNowApplying2: () => {
    return '契約者情報変更申請を承り中です。<br>変更申請の反映は申請後約５営業日です。<br><br>変更手続きが完了後、ユーザの追加を行ってください。';
  },
  alertNowApplying3: () => {
    return '契約者情報変更申請を承り中です。<br>変更申請の反映は申請後約５営業日です。<br><br>変更手続きが完了後、050番号の追加を行ってください。';
  },
  alertChangeApplication: () => {
    return '*の項目の変更申請は、内容確認が必要となるため、約5営業日後の反映となります。<br><br>反映タイミングが異なる複数項目の変更申請については、まとめて約5営業日後の反映となります。<br><br>050番号、ユーザIDの追加は、契約名義変更手続きが完了後に、お申込みいただけます。';
  },
  alertMessageEmptyText: () => {
    return '検索に一致する情報が見つかりませんでした';
  },
  alertEmptyList: () => {
    return '対象のデータがありません。';
  },
  fetchDataFailed: item => {
    return `${item}の取得に失敗しました。時間を空けて再度実行してください。`;
  },
  notExistItem: item => {
    return item + 'が存在しません。';
  },
  invoiceRequireNotSpecialCharacter: item => {
    return item + 'に「&<>"\'／」を入力しないでください。';
  },
  // #3056
  requireNot4BCharacter: (item, eChar) => {
    return item + 'に登録できない文字が含まれています。編集して再度登録してください。(該当の文字：' + eChar + ')';
  },
  alertUpperLimitExceeded: (item, maximum) => {
    return item + 'の登録は' + maximum + '件までです。';
  },
  alertExistItem: item => {
    return item + 'はすでに登録されています。';
  },
  requireTrialUserAdd: item => {
    return 'トライアルユーザーの上限は' + item + '人までです。';
  },
  // For Trial
  notifyTrialUserCanNotUseThisFunction: () => {
    return 'トライアルユーザーの方はこちらの機能を利用できません。';
  },
  notifyTrialUserCanNotSave: () => {
    return 'トライアルユーザーの方は着信フロー設定を保存できません。';
  },
  notifyTrialUserCanNotVoiceToText: () => {
    return 'トライアルユーザーの方は通話録音テキスト化設定をご利用できません。';
  },
  notifyTrialUserCanNotSaveOther: () => {
    return 'トライアルユーザーの方は声色・声調パラメータを保存できません。';
  },
  titleTextTrial: () => {
    return 'トライアルユーザーの方は外線番号が利用できません';
  },
  notifyTrialUserCanNotMakeGaiSenCall: () => {
    return 'トライアルユーザーは内線通話しかご利用いただけません。';
  },
  notifyTrialUserCanNotSaveBusinessHours: item => {
    return `トライアルユーザーの方は${item}を保存できません。`;
  },
  statusPhoneNumberTrial: () => {
    return 'トライアルの為番号無し';
  },
  alertTrialWalkThroughInUserAdd: () => {
    return 'トライアルユーザーの方は営業時間設定と着信フロー設定を保存できません。着信グループ設定に進みます。';
  },
  notifyUserAdd: () => {
    return 'ユーザーを追加しますか？<br>１ユーザー分 3,300円（税込）の料金が<br>今月分より加算されます。';
  },
  notifyUserAddTrial: () => {
    return 'ユーザーを追加しますか？';
  },
  notifyUserDelete: userID => {
    return userID + 'を削除しますか？<br>１ユーザー分 3,300円（税込）の料金が<br>翌月分より減算されます。';
  },
  notifyUserDeleteTrial: userID => {
    return userID + 'を削除しますか？';
  },
  canNotActiveDAccountForTrial: () => {
    return 'ビジネスdアカウント連携機能はトライアルユーザーではご利用できません。';
  },
  // self-reset-password
  selfResetPasswordResult: () => {
    return 'ご登録メールアドレスに新しいパスワードを送信しました。<br>※メールが届かない場合は契約ID、ユーザーIDに誤りがないかご確認ください。';
  },
  reNotifyCompanyIDSuccess: () => {
    return 'ご登録メールアドレスに契約IDを送信しました。<br>※メールが届かない場合はユーザーIDに誤りがないかご確認ください。';
  },
  notifyAbsentError: item => {
    return '通話が短すぎるか、または無音であるため、' + item + 'を実行できませんでした。';
  },
  maxUser: item => {
    return 'ユーザーの上限は' + item + '人までです。';
  },
  maxGroup: item => {
    return '着信グループの上限は' + item + '個までです';
  },
  requirePushNumberX: item => {
    return 'プッシュ番号' + item + 'を設定ください。';
  },
  requireMakeCall: item => {
    return item + 'のため発信できません。';
  },
  httpRequestError: item => {
    return item + ' response was not ok.';
  },
  notifySuccess: item => {
    return item + 'が成功しました。';
  },
  notifyCalledBusy: item => {
    return item + 'が通話中です。';
  },
  requireNumberInput: item => {
    return item + 'は半角数字で入力してください。';
  },
  requireMinRegister: (item, min) => {
    return item + 'は' + min + '件以下登録できません。';
  },
  requireMaxRegister: (item, max) => {
    return item + 'は' + max + '件以上登録できません。';
  },
  requireStringSizeMin: (item, min) => {
    return item + 'は' + min + '文字以上となっております。';
  },
  requireStringSizeMax: (item, max) => {
    return item + 'は' + max + '文字までとなっております。';
  },
  requirePermission: item => {
    return item + '機能は利用いただけません';
  },
  audioHintMessage: item => {
    return `選択肢のプルダウンでは、同じ選択肢名で「既定」「通信」「表記なし」の3つが表示される場合があります。
    <br />
    ご利用の端末によって接続方式が異なることがありますので、まず「既定」をお試しいただき、音声が聞こえない場合は「通信」または「表記なし」を選択し、接続をお試しください。
    <br />
    なお、PCと接続されているマイク・スピーカーの確認方法は<a
      id="manual"
      href="${item}"
      rel="noreferrer noopener"
      target="_blank"
      >ユーザーマニュアル</a
    >をご確認ください。`;
  },
  // Static message
  noData: `対象のデータがありません。`,
  pageNotFound: `お探しのページは削除されているか、<br />アドレスが異なっているため見つかりませんでした。`,
  pageNotFoundTitle: '404 Not found',
  recordingNotFound: `通話録音ファイルが取得できませんでした。`,
  permissionDenied: `ご利用アカウントではこちらのページは表示できません。`,
  permissionDeniedTrialTitle: 'トライアルでは',

  saveMemoMessage:
    '過去のメモ内容と合わせて1000文字を超えているため、追記して保存できません。<br/>どちらのメモを保存しますか？',
  previousMemoHelpContent:
    '通話が転送されてきた場合に転送元ユーザーが保存したメモ内容など、通話に対して過去に保存されたメモ内容が表示されます。<br/>「過去メモを更新」ボタンをクリックすると保存されている内容が読み込まれます。',
  currentMemoHelpContent: agentName => {
    return (
      '通話メモは通話に対して1000文字まで入力できます。<br/>※通話メモ内容の先頭にオペレータ名が以下の形式で自動で入力されますので、オペレータ名を含めて1000文字までとなります。<br/>　' +
      agentName +
      '<br/>※転送されてきた通話で転送元が保存したメモがある場合は、保存されたメモにこちらの入力内容が追記される形で記録されます。<br/>　過去に保存されたメモと合わせて1000文字までとなります。'
    );
  },
  // #3483 Salesforce連携設定
  notSetSfColumnSettings: column => {
    return '下記の連携先項目が未設定です。<br/>' + column;
  },
  sfSettingsSaveComplete: 'Salesforce連携設定を保存しました。',
  sfSettingsSaveError: 'Salesforce連携設定を保存できませんでした。時間を空けて再度実行してください。',
  sfCreateTestRecordComplete:
    'Salesforce連携機能のテストに成功しました。<br/>Salesforceにログインしてテストレコードが作成されていることを確認してください。',
  sfCreateTestRecordErrorText:
    'Salesforce連携機能のテスト中にエラーが発生しました。<br/>ユーザーのSalesforceログイン情報や連携先項目の設定を確認してください。',
  sfCreateTestRecordError: message => {
    return 'Salesforce連携機能のテスト中にエラーが発生しました。<br/>【エラー内容】<br/>' + message;
  },
  loginInputError: 'すべての項目に値を入力してください。',
  loginCompanyIdDigitError: '契約IDを6文字または9文字で入力してください。',
  loginCompanyIdFormatError: '契約IDの入力形式に誤りがあります。',
  loginEmailInputError: 'メールアドレスを入れてください。',
  loginCsrfExpiredError: 'セッションが切れました。ページをリロードした後再度実行してください。',
  sessionAboutToExpireWarning:
    'あと60分で自動ログアウトします。\nログアウトさせない場合は画面を操作するか、画面のリフレッシュを行ってください。',
  loginEmailAuthSend: 'ご登録のメールアドレスに、メールリンク認証用のURLを送付いたしましたのでご確認ください。',
  loginEmailAuthResend:
    'ご登録のメールアドレスに、メールリンク再認証用のURLを送付いたしました。再度IDとパスワードを入力してログインしてください。',
  dauthLoginError: 'ログインできません。数秒後にログイン画面を表示します。',
  loginOtherError: 'ログイン中にエラーが発生しました。ページをリロードした後再度実行してください。',
  loginTestCallError: 'お試し通話中にエラーが発生しました。ページをリロードした後再度実行してください。',
  logoutOtherError: 'ログアウト中にエラーが発生しました。時間を空けて再度実行してください。',
  noMailAuthTitle: 'メールリンク認証を実施してください',
  noMailAuthMessage: `ご登録のメールアドレスに認証用のURLを送付しております。<br />ご確認いただき、認証用URLからのアクセスをお願いいたします。`,
  numbermgmtGetCompanyIdError: '契約ID取得中にエラーが発生しました。時間を空けて再度実行してください。',
  numbermgmtDataTableEmptyText: '検索に一致する情報が見つかりませんでした',
  numbermgmtGetNumberError: '電話番号情報の取得中にエラーが発生しました。時間を空けて再度実行してください。',
  numbermgmtSaveNumberError: '電話番号情報の保存中にエラーが発生しました。時間を空けて再度実行してください。',
  numbermgmtFdndHalfError: 'FD/ND番号は半角数字で入力してください。',
  numbermgmtFdndSaveError: 'FD/ND番号の保存に失敗しました。',
  numbermgmtFdndDeleteError: 'FD/ND番号の削除に失敗しました。',
  numbermgmtFdndPrevNumberDeleteError: '変更前のFD/ND番号の削除に失敗しました。',
  numbermgmtNoteSaveComplete: '備考を保存しました。',
  numbermgmtNoteSaveError: '備考の保存に失敗しました。',
  numbermgmtCsvUploadError: 'CSVアップロード中にエラーが発生しました。時間を空けて再度実行してください。',
  numbermgmtCsvDownloadError: '電話番号情報CSVのダウンロードに失敗しました。',
  numbermgmtFdndNumberOnly0120: 'FD番号(0120)は数値のみで入力してください。',
  numbermgmtFdndInitialCheck0120: 'FD番号(0120)は「0120」から始まる数値を入力してください。',
  numbermgmtFdndCheck0120: 'FD番号(0120)は10桁で入力してください。',
  numbermgmtFdndNumberOnly0800: 'FD番号(0800)は数値のみで入力してください。',
  numbermgmtFdndInitialCheck0800: 'FD番号(0800)は「0800」から始まる数値を入力してください。',
  numbermgmtFdndCheck0800: 'FD番号(0800)は11桁で入力してください。',
  numbermgmtFdndNumberOnly0570: 'ND番号は数値のみで入力してください。',
  numbermgmtFdndInitialCheck0570: 'ND番号は「0570」から始まる数値を入力してください。',
  numbermgmtFdndCheck0570: 'ND番号(0570)は10桁で入力してください。',
  numbermgmtFdndCheckAll: 'FD/ND番号は0120・0570から始まる10桁、または0800から始まる11桁の数値を入力してください。',
  numbermgmtBzcsvDownloadError: 'CSVダウンロード中にエラーが発生しました。時間を空けて再度実行してください。',
  numbermgmtFdndApproveError: '開通中にエラーが発生しました。時間を空けて再度実行してください。',
  numbermgmtSoCancelError: 'SOキャンセル中にエラーが発生しました。時間を空けて再度実行してください。',
  numbermgmtCancelError: '廃止中にエラーが発生しました。時間を空けて再度実行してください。',
  numbermgmtFdndUploadError: 'FD/ND番号のアップロードに失敗しました。再度アップロードを行ってください。',
  notificationGranted: 'ブラウザの通知設定が許可されています。',
  notificationDenied: 'ブラウザの通知設定がブロックされています。',
  notificationDefault: 'ブラウザの通知設定を確認してください。',
  notificationDisable: 'ブラウザの通知設定を取得できませんでした。',
  notificationSettingError: 'ブラウザの通知設定の取得時にエラーが発生しました。',
  passwordInputError: 'すべての項目に値を入力してください。',
  newPasswordError: '新しいパスワードが一致しません。再度入力してください。',
  passwordFormatError:
    'パスワードは12文字〜40文字で、<br>大文字アルファベット、小文字アルファベット、数字をすべて１つ以上含ませてください。',
  userInfoEmailError: 'メールアドレスを入れてください。',
  userInfoUsernameError: '登録名を入力してください。',
  userInfoUpdateSuccess: '設定を変更しました。',
  userInfoUpdateFailed: '設定を変更できませんでした。時間を空けて再度実行してください。',
  userSettingsCheckModalTitle: 'ユーザー情報保存前の確認',
  emptySfPasswordMessage:
    '「Salesforceのパスワード」欄が未入力のため、Salesforceのパスワードは保存・変更されません。よろしいですか？',
  resetPasswordFailure: 'パスワードリセットに失敗しました。',
  reNotifyCompanyIDFailure: '契約ID再通知申請に失敗しました。',
  businessHoursConflictSetting: '営業時間と24時間営業のチェックを同時に入力することはできません',
  requireBusinessHours: '有効な曜日の場合、営業時間を1つ以上入力してください',
  businessHoursSettingCompleted: '営業時間設定が完了しました。',
  updateSettingError: '設定変更中にエラーが発生しました。時間を空けて再度実行してください。',
  noOperationPermission: 'ご利用アカウントではこちらの操作はできません。',
  exceedMaxHolidays: '休業日が30日以上設定されています。',
  holidaysEmpty: '休業日が空で設定されています。',
  holidaysSettingCompleted: '休日設定が完了しました。',
  incorrectEmailFormat: 'メールアドレスのフォーマットが正しくありません。',
  invalidDigitsNumberOfPhoneNumber: '電話番号は10桁または11桁を入力してください。',
  phonenumberIsNotHalfWidth: '電話番号は半角数字で入力してください。',
  requirePhonenumberOfVDXB: 'COTOHA Voice DX Basicでご契約の電話番号を選択してください。',
  correspondenceSettingCompleted: '営業時間外の対応設定が完了しました。',
  exceptionDaySettingCompleted: '例外日の対応設定が完了しました。',
  breakTimeSettingCompleted: '休憩時間の対応設定が完了しました。',
  settingSavingError: '設定保存中にエラーが発生しました。時間を空けて再度実行してください。',
  emptyGuidanceError: 'ガイダンス内容を入力してください。',
  playbackError: '再生中にエラーが発生しました。時間を空けて再度実行してください。',
  contractIDProhibited: '入力された契約IDは使用が禁止されています。',
  contractIDInUse: 'この契約IDは既に使用されています。',
  requireinPersonTransactionFlag: '取引種別を選択してください。',
  requireBeneficialOwner: '実質的支配者の有無を選択してください。',
  canNotRegisterCompanyInfo: '企業情報を登録できませんでした。時間を空けて再度実行してください。',
  companyInfoUpdated: '企業情報を変更しました。',
  canNotUpdateCompanyInfo: '企業情報を変更できませんでした。時間を空けて再度実行してください。',
  voiceToTextSettingUpdated: '通話録音テキスト化の利用設定を変更しました。',
  canNotUpdateVoiceToTextSetting:
    '通話録音テキスト化の利用設定を変更できませんでした。時間を空けて再度実行してください。',
  canNotDeleteUncanceledContract: '解約していない契約IDは削除できません。',
  passwordEmailed: '新しいパスワードをメール送信しました。',
  canNotResetPassword: 'パスワードリセットできませんでした。時間を空けて再度実行してください。',
  requirePushNumber: '最低一つのプッシュ番号を設定ください。',
  requireIncomingGroupName: '着信グループ名入力してください。',
  requireUser: 'ユーザーを選択してください。',
  exceedMaxUserPerGroup: '一斉着信は最大10名まで指定してください。',
  requireIncomingGroup: '着信グループ選択してください。',
  requirePhonenumber: '電話番号を入力してください。',
  requireSettingName: '設定名称入力してください。',
  requireCorrespondingMethod: '対応方法選択してください。',
  selectIncomingGroupName: '着信グループ名選択してください。',
  notificationSettingUpdated: 'お知らせの設定を変更しました。',
  responseAvailabilitySettingUpdated: 'ログイン時の応答可否設定を変更しました。',
  autoInputMemmoOperatorNameSettingUpdated: '通話メモのオペレータ名自動入力設定を変更しました。',
  dictionarySettingUpdated: 'キーワードの設定を変更しました。',
  trialInfoUpdated: 'トライアル情報を変更しました。',
  trialInfoUpdateFailed: 'トライアル情報を変更できませんでした。時間を空けて再度実行してください。',
  requireAtLeast1UserPerGroup: 'グループには最低一人以上紐付ける必要があります。',
  upTo10MembersPerGroup: '着信グループのメンバー登録は10名までです。',
  userDeleted: 'ユーザーを削除しました。',
  changedEmailUpdateScreen: '削除対象のユーザーのメールアドレスが変更されています。<br>画面を更新してください。',
  incomingGroupDeleted: '着信グループを削除しました。',
  suspensionSettingSaved: '利用停止設定を保存しました。',
  failedToSaveSuspension: '利用停止設定の保存に失敗しました。',
  suspendsTheSelectedUser: '選択されているユーザーを利用停止にします。',
  isThisGood: 'よろしいでしょうか？',
  userAdded: 'ユーザーを追加しました。',
  canNotAddUserDueToContractCanceled: '解約済みのためユーザー追加はできません。',
  reachUserCountLimit: item => {
    return '追加できるユーザー数の上限値（' + item + '）を超過するため、これ以上のユーザー追加を行うことはできません';
  },
  requireSalesforceEmail: 'Salesforceのユーザ名はメールアドレス形式で入力してください。',
  canNotActiveDAccountDueToMailAuthenticating:
    'このユーザーはメールリンク認証が必要なユーザーのため、dアカウント連携設定を有効にできません。メールリンク認証後に一度ログインしてから有効にしてください。',
  canNotActiveDAccountDueToUserBlocked:
    'こちらのユーザーは現在ロック状態になっているためdアカウント連携設定を有効にできません。パスワードリセットでロックを解除し一度ログインしてから有効にしてください。',
  canNotResetPasswordDueToDAccountLinking:
    'ビジネスdアカウント連携ONに設定されているユーザーはパスワードリセット機能が使えません。',
  explainDictionary1:
    'よく使う単語や専門用語などをご登録いただくと、発話された音声からキーワードがテキスト化される可能性が高まります。',
  explainDictionary2:
    'テキスト化される確率は、「高」に設定すると高い確率でそのキーワードがテキスト化されますが、曖昧な発音や文脈上適切していない場合',
  explainDictionary3:
    'もキーワードがテキスト化されることもあるので、設定後にテキスト化される内容を確認して調整してください。',
  fetchReady050NumberListError: '050番号情報の取得中にエラーが発生しました。時間を空けて再度実行してください。',
  requireFullWidthCharacter: '全角文字で入力してください。',
  editNumberNameError: '番号名称の修正中にエラーが発生しました。時間を空けて再度実行してください。',
  canNotCancel050NumberDueToOneLeft:
    '050番号が1つのみの場合、この番号の廃止を行うことはできません。<br>今後COTOHA Call Centerの利用予定が無い場合は「契約情報確認・変更」メニューより解約申込を実施ください。',
  canNotCancel050NumberDueToFDNDLinking: '連携しているフリーダイヤルナビダイヤルがある為、廃止申込できません。',
  cancel050NumberError: '050番号の廃止申込中にエラーが発生しました。時間を空けて再度実行してください。',
  fdndApplyOK: item => {
    return item + 'のお申し込みを受け付けました。';
  },
  fdndCancelOK: item => {
    return (
      item +
      '廃止のお申し込みを受け付けました。<br />お申し込み内容確認のため、弊社よりご連絡させていただく場合がございますので、ご了承ください。'
    );
  },
  number050Added: '電話番号の新規登録が完了しました。',
  add050NumberError: '050番号追加中にエラーが発生しました。時間を空けて再度実行してください。',
  number050AlreadyFull: 'ご利用中の050番号数が上限に達している為、番号の追加を行うことはできません。',
  notifyTwilioDeviceNotReadyWarning: '応答可能に変更してください。',
  recordingHelpMessageTitle: '通話録音の提供上限時間について',
  recordingHelpMessageContent: '60分を超える通話録音の再生については現在ご利用いただけません。',
  notifyPendingPhoneNumber: 'ご利用の外線電話番号は利用停止中です。電話番号のステータスを確認してください。',
  notifyCalledDisconnected: '通話相手が切断しました。',
  notifyPendingTransferPhoneNumber: '転送先のユーザは利用停止中のため転送できません。',
  confirmForceUpdateUserID: userID => {
    return `ユーザーIDを以下のメールアドレスに変更しようとしています。本当によろしいでしょうか？<br><span class="o-modal__highlight-email">${userID}</span><br>ユーザーID変更後の初回ログイン時は現在のパスワードをそのまま利用できます。`;
  },
  requireSameUser: '別のユーザーが現在こちらのリストを使用しているため操作できません。',
  notifyWrongNumberFormatCSV: '登録できない番号が含まれています。CSVファイルを修正してください。',
  reachedRepeatLimit: '繰り返し回数を超えることはできません。',
  notifyAllCallLocked: 'まだ未実施の番号が存在するため、電話番号リストの繰り返しができません。',
  chromeMicroPermissionError:
    '利用ブラウザのマイクとスピーカーの許可設定をしてください。<br>「chrome マイク 許可」などでインターネット検索をすると、手順を確認することができます。',
  notifyMaxCall: '発信回数は3回を超えた実行はできません。',
  notifyAllPhoneUnlocked: '全ての番号のロックを解除しました',
  notifyCannotSaveMemo: '正常に通話開始できなかったため、メモの保存はできません。',
  outboundRejectIncomingCall: 'アウトバウンド発信するため現在着信中のコールを拒否します。よろしいでしょうか？',
  notifyStartFlagIsFalse: 'こちらのリストは停止中のため、架電できません。',
  notifyAllPhoneAreLocked: `他のユーザーが対応中の架電先が残っているため<br />次の繰り返しに進めません。<br /><br />パソコンのスリープや電源断などで<br />意図せず他のユーザーで対応中のままとなっている場合は、<br />管理者より解除を実施してください。`,
  required15MinutesUnits: '15分単位で入力してください',
  notifyOutboundDataHasChanged:
    'こちらのリストは既に別の操作がされております。ページリロードし最新状態を表示してください。',
  notSameGroupName: '元の着信グループとあふれ呼の着信グループは同じグループを選択できません。',
  notifyPhoneNumberCannotUse: '発信番号が廃止中か利用停止中のため、架電できません。',
  notifyDeletedList: 'リストが削除されているため架電できません',
  silentTextMessage: 'テキスト化対象が存在しない為、表示内容はございません',
  notifyPageRefreshed: '画面をリフレッシュしました。',
  businessHoursVoiceGuidancePlaceHolder: `お電話ありがとうございます。⚫︎⚫︎株式会社でございます。
申し訳ございませんが、ただいまの時間は受付時間外となっております。
弊社営業時間は、祝日を除く、月曜から金曜の9時から17時半です。
お急ぎのご用件でしたら、発信音の後に、ご用件とお名前をご伝言ください。
お電話ありがとうございました。`,
  businessHoursVoiceGuidanceNoMessagePlaceHolder: `お電話ありがとうございます。⚫︎⚫︎株式会社でございます。
申し訳ございませんが、ただいまの時間は受付時間外となっております。
弊社営業時間は、祝日を除く、月曜から金曜の9時から17時半です。
誠に恐れ入りますが、営業時間内におかけ直し頂きますよう、お願い申し上げます。
お電話ありがとうございました。`,
  breakTimeHoursVoiceGuidancePlaceHolder: ``,
  breakTimeHoursVoiceGuidanceNoMessagePlaceHolder: `お電話有難うございます。⚫︎⚫︎株式会社でございます。
申し訳ございませんが、ただいまの時間はお昼休みとなっております。
誠に恐れ入りますが、13時以降におかけ直し頂きますよう、お願い申し上げます。
お電話ありがとうございました。`,
  confirmForceUpdateAdminEmail: adminEmail => {
    return `以下のメールアドレスに変更しようとしています。本当によろしいでしょうか？<br><span class="o-modal__highlight-email">${adminEmail}</span>`;
  },
  invalidPasscode: '6桁の数字のみを入力してください。',
  passcodeWrong: 'ログインできません。<br>※メールに記載の認証コードをご確認ください。',
  passcodeAuthFailed: '二要素認証に失敗しました。<br>再度IDパスワードでログインしてください。',
  fileFormat: '※対応するファイル形式は.jpeg .jpg .png .pdfです。',
  // Outbound list
  csvUploadFileRequired: 'CSVファイルをアップロードしてください',
  csvSelectRequired: 'CSVファイルを選択してください。',
  csvFileEncodingNotUTF8: 'CSVファイルの文字コードがUTF-8以外に設定されています',
  callDestinationNameLineXXRequired: no => `[${no}行]　架電先名称は必須です。`,
  callDestinationNameLineXXLengthExceeded: no => `[${no}行]　架電先名称は200文字までです。`,
  callDestinationNameLineXXIncludeSpecialCharacters: no => `[${no}行]　登録できない架電先名称です。`,
  callDestinationLineXXRequired: no => `[${no}行]　架電番号は必須です。`,
  callDestinationLineXXInvalid: no => `[${no}行]　登録できない架電番号です。`,
  lineXXInvalidSpecificNumber: no => `[${no}行]　登録できない特定番号です。`,
  defaultVoicemailGuidance: companyName =>
    `お電話ありがとうございます。${companyName}株式会社でございます。\n申し訳ございませんが、ただいまの時間は電話が込み合っています。\nお急ぎのご用件でしたら、発信音の後に、ご用件とお名前をご伝言ください。お電話ありがとうございました。`,
  defaultDisconnectGuidance: companyName =>
    `お電話ありがとうございます。${companyName}株式会社でございます。\n申し訳ございませんが、ただいまの時間は電話が込み合っています。\n誠に恐れ入りますが、営業時間内におかけ直し頂きますよう、お願い申し上げます。\nお電話ありがとうございました。
    `,
  specificNumberRequired: '特定番号を指定してください。',
  specificNumberNotificationEmailRequired: 'メール通知を入力してください。',
  specificNumberGroupCanNotSameAsOverflowGroup:
    '元の着信グループと特定番号対応の着信グループは同じグループを選択できません。',
  alreadyEmail: '入力されたメールアドレスは登録済みです。',
  contractEdit: '契約名義変更がされています。「変更を申請」を押してから処理を再開してください。',
  authCodeErr1: 'コードの有効期限切れ、または有効回数を超えました。',
  authCodeErr2: '入力された認証コードは無効です。',
  noticeNoPhoneBookRegisterd: '新規登録するデータがありません。',
  noticeNoPhoneBookDeleted: '削除するデータがありません。',
  VDXFDNDLinking: `AIオペレータ機能（COTOHA Voice DX Basic）で利用している番号を全て削除しないと解約できません。`,
  FDNDLinkingWarning: `解約にはフリーダイヤル/ナビダイヤルとの連携を全て解除する必要がございます。<br>電話番号管理画面からフリーダイヤル/ナビダイヤルの連携解除/廃止が可能です。<br><br>電話番号管理画面に移動しますか？`,
  vdxPhonenumberContractingWarning: `解約にはAIオペレータ機能（COTOHA Voice DX Basic）で利用している番号を全て削除する必要がございます。<br><br>番号の削除を実施しますか？`,
  defaultRelocationGuidance: `おかけになった電話番号が変わりました。\n新しい番号は、△△△△△△△△△△です。`,
  invoiceCompanyRequired: '請求書送付先 請求書送付先①を入力してください。',
  hasSpecialCharacterInvoiceName: `「&<>"'／」を入力しないでください。`,
};
